import { Sparkles } from "lucide-react";
import { Card } from "@/components/ui/card";
import { Eyebrow, IconChip, FadeIn } from "./primitives";

export const InsightsSection = () => (
  <FadeIn>
    <Card className="p-6 shadow-soft sm:p-7">
      <Eyebrow>This Week</Eyebrow>
      <div className="mt-4 flex items-start gap-4">
        <IconChip icon={Sparkles} active />
        <div>
          <h3 className="font-display text-[22px] font-medium leading-snug tracking-tightish text-foreground sm:text-2xl">
            Nothing yet — and that’s fine.
          </h3>
          <p className="mt-2 max-w-xl text-[14px] leading-relaxed text-muted-foreground">
            Insights are gentle observations the app makes from your own writing,
            once there’s a little to observe. There’s no rush.
          </p>
        </div>
      </div>
    </Card>
  </FadeIn>
);
